import React from 'react';
import { ProcessedChildren } from '../ProcessedChildren/ProcessedChildren';

export const ParagraphRenderer = ({
  children,
  noParagraph,
  className,
}: {
  children: React.ReactNode;
  noParagraph?: boolean;
  className?: string;
}) => {
  if (noParagraph) {
    return (
      <span className={className}>
        <ProcessedChildren>{children}</ProcessedChildren>
      </span>
    );
  }

  return (
    <p className={className}>
      <ProcessedChildren>{children}</ProcessedChildren>
    </p>
  );
};
